import { SET_FORMALITY_REQUEST } from "../actions/FormalityActions";

const initialState = {
  formalityRequest: null,
};

const formalityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORMALITY_REQUEST:
      return {
        formalityRequest: action.payload,
      };

    default:
      return state;
  }
};

export default formalityReducer;
